import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const StyledDiv = styled('div')(
  ({ theme }) => ({
    color: theme.palette.body.color,
    marginLeft: '2%',
  })
)

const StyledHeading = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.body.white,
    fontSize: '2.5em',
  })
);

function Maintenance(prop) {
  return (
    <StyledDiv>
      <StyledHeading variant='h1'>Maintenance/After Care Tips: </StyledHeading>
    </StyledDiv>
  )
}

export default Maintenance;